module.exports = __webpack_public_path__ + "static/img/categories1.7dadbe8.png";


//////////////////
// WEBPACK FOOTER
// ./static/recycle/categories1.png
// module id = tCUS
// module chunks = 1